import { render, staticRenderFns } from "./SelecionarModulo.vue?vue&type=template&id=169e8cc8&scoped=true&lang=pug&"
import script from "./SelecionarModulo.vue?vue&type=script&lang=js&"
export * from "./SelecionarModulo.vue?vue&type=script&lang=js&"
import style0 from "./SelecionarModulo.vue?vue&type=style&index=0&id=169e8cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e8cc8",
  null
  
)

export default component.exports